module.exports = __webpack_public_path__ + "img/holiday-2.a4004ee1.svg";